module.exports = __webpack_public_path__ + "static/media/timer.c349cef0.png";